/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");

/**
 * jQuery plugin truncate
 *
 * Source: https://github.com/tbasse/jquery-truncate
 * Originally released under the MIT License.
 */
/* eslint complexity: [error, 10] */
/* global jQuery */
(function ($) {
    /**
     * Checks whether the given param is a number or not.
     * @param n The value to check.
     */
    function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
     * Recursive method to find out what fits inside an element with the width of 'max'.
     *
     * @param data A complex parameter object, which contains all items required. The object's attributes:
     *             - dimension The dimension to check, usually 'width'.
     *             - max The maximum number of that dimension, e.g. width of 90px.
     *             - text The original text.
     *             - start The start point of the text (changes in recursive call).
     *             - end The end point of the text (changes in recursive call).
     *             - $workerEl The worker which concats the final text.
     *             - token The token which is inserted, e.g. '&hellip;'.
     *             - fromEnd Defines whether to check from end or not.
     */
    function findTruncPoint(data) {
        var opt1,
            opt2,
            mid;

        if (data.fromEnd) {
            opt1 = data.start === 0 ? '' : data.text.slice(-data.start);
            opt2 = data.text.slice(-data.end);
        } else {
            opt1 = data.text.slice(0, data.start);
            opt2 = data.text.slice(0, data.end);
        }

        if (data.max < data.$workerEl.text(data.token)[data.dimension]()) {
            return 0;
        }

        if (data.$workerEl.text(opt2 + data.token)[data.dimension]()
                < data.$workerEl.text(opt1 + data.token)[data.dimension]()) {
            return data.end;
        }

        mid = parseInt((data.start + data.end) / 2, 10);
        opt1 = data.fromEnd ? data.text.slice(-mid) : data.text.slice(0, mid);

        data.$workerEl.text(opt1 + data.token);
        if (data.$workerEl[data.dimension]() === data.max) {
            return mid;
        }

        if (data.$workerEl[data.dimension]() > data.max) {
            data.end = mid - 1;
        } else {
            data.start = mid + 1;
        }

        return findTruncPoint(data);
    }

    /**
     * the jQuery extension. These are the possible options:
     * - width:                'auto' or a numeric value
     * - token:                The string which will be displayed as the delimiter, standard is '&hellip;' (...).
     * - center:            boolean value defining whether the ellipsis is going to be in the text, not after it.
     * - visibleTrailChars:    numeric value defining how many characters should be shown after the ellipsis.
     *                         If the value is bigger then what fits into the displayed element, truncate will switch
     *                         to standard centered mode.
     * - addclass:            false or a string for the classname that should be added.
     * - addtitle:            boolean value, defines whether a title attribute containing the full text should be
     *                         added to the element.
     * - multiline:         boolean value, defines whether the element is multiline or not.
     */
    $.fn.truncate = function (options) {
        var defaults = {
            width: 'auto',
            token: '&hellip;',
            center: true,
            addclass: false,
            addtitle: true,
            multiline: false
        };
        options = $.extend(defaults, options);

        return this.each(function () {
            var $element = $(this),
                fontCSS = {
                    'fontFamily': $element.css('fontFamily'),
                    'fontSize': $element.css('fontSize'),
                    'fontStyle': $element.css('fontStyle'),
                    'fontWeight': $element.css('fontWeight'),
                    'font-variant': $element.css('font-variant'),
                    'text-indent': $element.css('text-indent'),
                    'text-transform': $element.css('text-transform'),
                    'letter-spacing': $element.css('letter-spacing'),
                    'word-spacing': $element.css('word-spacing'),
                    'display': 'none'
                },
                elementText = $element.text(),
                $truncateWorker = $('<span/>').css(fontCSS).text(elementText).appendTo('body'),
                originalWidth = $truncateWorker.width(),
                truncateWidth = isNumber(options.width) ? options.width : $element.width(),
                dimension = 'width',
                truncatedText, originalDim, truncateDim, lastCharsWidth, $lastCharsTruncateWorker;

            if ($.trim(elementText).length < 2) {
                return false;
            }

            if (options.multiline) {
                $truncateWorker.width($element.width());
                dimension = 'height';
                originalDim = $truncateWorker.height();
                truncateDim = $element.height() + 1;
            } else {
                originalDim = originalWidth;
                truncateDim = truncateWidth;
            }

            if (isNumber(options.visibleTrailChars)) {
                $lastCharsTruncateWorker = $('<span/>').css(fontCSS).text(
                            elementText.slice(-1 * options.visibleTrailChars)
                        ).appendTo('body');
                lastCharsWidth = $lastCharsTruncateWorker.width();
            }

            if (originalDim > truncateDim) {
                $truncateWorker.text('');
                if (options.center) {
                    if (isNumber(options.visibleTrailChars) && lastCharsWidth < truncateDim) {
                        var secondTruncateDim = lastCharsWidth;
                        var firstTruncateDim = truncateDim - secondTruncateDim;
                        truncatedText = elementText.slice(0, findTruncPoint({
                                dimension: dimension,
                                max: firstTruncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: options.token,
                                fromEnd: false
                            }))
                        + options.token
                        + elementText.slice(-1 * findTruncPoint({
                                dimension: dimension,
                                max: secondTruncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: '',
                                fromEnd: true
                            }));
                    } else {
                        truncateDim = parseInt(truncateDim / 2, 10) + 1;
                        truncatedText = elementText.slice(0, findTruncPoint({
                                dimension: dimension,
                                max: truncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: options.token,
                                fromEnd: false
                            }))
                        + options.token
                        + elementText.slice(-1 * findTruncPoint({
                                dimension: dimension,
                                max: truncateDim,
                                text: elementText,
                                start: 0,
                                end: elementText.length,
                                $workerEl: $truncateWorker,
                                token: '',
                                fromEnd: true
                            }));
                    }
                } else {
                    truncatedText = elementText.slice(0, findTruncPoint({
                        dimension: dimension,
                        max: truncateDim,
                        text: elementText,
                        start: 0,
                        end: elementText.length,
                        $workerEl: $truncateWorker,
                        token: options.token,
                        fromEnd: false
                    })) + options.token;
                }

                if (options.addclass) {
                    $element.addClass(options.addclass);
                }

                if (options.addtitle) {
                    $element.attr('title', elementText);
                }

                $element.empty().text(truncatedText);

            }

            $truncateWorker.remove();
            $lastCharsTruncateWorker.remove();
        });
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./shared/modules/jquery.truncate.js
// module id = 16
// module chunks = main